export const beneficiaryDetailCivilStatusEnum: Record<string, string> = {
  CASADO: 'Casado',
  SOLTEIRO: 'Solteiro',
  VIUVO: 'Viúvo',
  DESQUITADO: 'Desquitado',
  SEPARADO: 'Separado',
  OUTROS: 'Outros',
};
